import { route } from '../../../constants.ts';

export const CHANGE_PREVIEW_MODE = `${route}/CHANGE_PREVIEW_MODE`;
export const CHANGE_PREVIEW_SCENE_ID = `${route}/CHANGE_PREVIEW_SCENE_ID`;
export const REQUEST_CHANGE_PREVIEW_SCENE_ID = `${route}/REQUEST_CHANGE_PREVIEW_SCENE_ID`;
export const CHANGE_SCENE = `${route}/CHANGE_SCENE`;
export const CHANGE_ENVIRONMENT_MAP = `${route}/CHANGE_ENVIRONMENT_MAP`;
export const CHANGE_CAMERA = `${route}/CHANGE_CAMERA`;
export const CHANGE_MOUSE = `${route}/CHANGE_MOUSE`;
export const RESET_CAMERA = `${route}/RESET_CAMERA`;
export const SHOW_SCENE_CODE = `${route}/SHOW_SCENE_CODE`;
export const CHANGE_DRAG_ACTION = `${route}/CHANGE_DRAG_ACTION`;

export function changePreviewMode({ modeGroup, modeType }, transient = false) {
    return {
        type: CHANGE_PREVIEW_MODE,
        payload: { modeGroup, modeType, transient },
    };
}

export function changePreviewSceneId(sceneId, transient = false) {
    return {
        type: CHANGE_PREVIEW_SCENE_ID,
        payload: { sceneId, transient },
    };
}

export function requestChangePreviewSceneId(sceneId, transient = false) {
    return {
        type: REQUEST_CHANGE_PREVIEW_SCENE_ID,
        payload: { sceneId, transient },
    };
}

export function changeScene({ sceneId, path, value, transient = false }) {
    return {
        type: CHANGE_SCENE,
        payload: { sceneId, path, value, transient },
    };
}

export function changeEnvironmentMap({ sceneId, mapId }) {
    return {
        type: CHANGE_ENVIRONMENT_MAP,
        payload: { sceneId, mapId },
    };
}

export function changeCamera({ camera, transient = false }) {
    return {
        type: CHANGE_CAMERA,
        payload: { camera, transient },
    };
}

export function changeMouse({ mouse, transient = false }) {
    return {
        type: CHANGE_MOUSE,
        payload: { mouse, transient },
    };
}

export function resetCamera() {
    return {
        type: RESET_CAMERA,
        payload: {},
    };
}

export function showSceneCode() {
    return {
        type: SHOW_SCENE_CODE,
        payload: {},
    };
}

export function changeDragActionGroup(dragActionGroup) {
    return {
        type: CHANGE_DRAG_ACTION,
        payload: { dragActionGroup },
    };
}

export const CHANGE_SHOW_SCENE_BACKGROUND = `${route}/CHANGE_SHOW_SCENE_BACKGROUND`;

export function changeShowSceneBackground(show) {
    return {
        type: CHANGE_SHOW_SCENE_BACKGROUND,
        payload: { show },
    };
}
